import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

const KEY_TO_LABEL = {
  agencyOrganization: "Project Agency",
  analystName: "Project Analyst",
  county: "County",
  municipality: "City",
  majorFacility: "Major Facility",
  EWFacilityName: "East-West Facility Name",
  NSFacilityName: "North-South Facility Name",
  additionalNotes: "Additional Project Notes",
  evaluationType: "Evaluation Type",
  projectName: "Project Name",
};

export default function ProjectInformationReport({ projectData }) {
  return (
    <Grid container spacing={2}>
      {Object.entries(projectData.projectInfo)?.map(([key, value]) => {
        if (key in KEY_TO_LABEL) {
          return (
            <React.Fragment key={key}>
              <Grid item sx={{ fontWeight: "700", textAlign: "right" }} xs={6}>
                {KEY_TO_LABEL[key]}
              </Grid>
              <Grid sx={{ textAlign: "left" }} item xs={6}>
                {value}
              </Grid>
            </React.Fragment>
          );
        } else {
          return "";
        }
      })}
    </Grid>
  );
}

ProjectInformationReport.propTypes = {
  projectData: PropTypes.shape({
    agencyOrganization: PropTypes.string,
    analystName: PropTypes.string,
    county: PropTypes.string,
    municipality: PropTypes.string,
    majorFacility: PropTypes.string,
    EWFacilityName: PropTypes.string,
    NSFacilityName: PropTypes.string,
    additionalNotes: PropTypes.string,
    evaluationType: PropTypes.string,
    projectName: PropTypes.string,
  }).isRequired,
};
